module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"watch":"Watch the demo","stop":"Stop the demo","canAsk":"Can ask questions","from":"from","ai":"AI","dictor":"Dictor","aiAvatar":"AI Avatar","voicingAnyQ":"Voicing any questions","maxQuestios":"Maximum number of questions"}}')
  delete Component.options._Ctor
}
